import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { motion } from "framer-motion";
import construction from '../../assets/images/webpage.png'

const MotionTypography = motion(Typography);
const MotionBox = motion(Box);

const ComingSoon = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        // background: "linear-gradient(135deg, #1a1a2e, #16213e)",
        background:"#f5f5f5",
        color: "#333",
        textAlign: "center",
        flexDirection: "column",
        gap: 2,
        p: { xs: 3, md: 6 },
      }}
    >
      {/* Animated Typography */}
      <MotionTypography
        variant="h2"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        sx={{ fontWeight: "bold", textShadow: "0px 4px 10px rgba(0,0,0,0.5)" }}
      >
        Coming Soon 🚧
      </MotionTypography>

      <MotionTypography
        variant="h6"
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3 }}
        sx={{ maxWidth: "600px", mx: "auto"}}
      >
        We are working hard on this page. It will be available soon! Please check
        back later.
      </MotionTypography>

      {/* Illustration */}
      <MotionBox
        component="img"
        src={construction}
        alt="Under Construction"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.5 }}
        sx={{
          maxWidth: "300px",
        //   borderRadius: "10px",
        //   mt: 2,
        //   boxShadow: "0px 4px 20px rgba(0,0,0,0.3)",
        }}
      />

      {/* Button to Navigate */}
      <MotionBox
        whileHover={{ scale: 1.05 }}
        // sx={{ mt: 4 }}
      >
        <Button
          variant="contained"
          sx={{
            background: "linear-gradient(90deg, #06beb6, #48b1bf)",
            color: "white",
            fontWeight: "bold",
            px: 4,
            py: 1.5,
            borderRadius: "30px",
            boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
            "&:hover": {
              background: "linear-gradient(90deg, #48b1bf, #06beb6)",
            },
          }}
          onClick={() => window.location.href = "/"}
        >
          Go to Homepage
        </Button>
      </MotionBox>
    </Box>
  );
};

export default ComingSoon;
